import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Col } from '../../lib/utils';
import { Head4, Body2Bold, Body3Regular, CaptionRegular } from '../../lib/font';
import { colors } from '../../lib/colors';

const MemberPaymentFailPage: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get('type') || 'payment';
    const message = queryParams.get('message') || '';
    const requestId = queryParams.get('requestId') || '';

    const isBilling = type === 'billing';

    const handleRetry = () => {
        if (requestId) {
            navigate(`/pay/${requestId}`);
        }
    };

    return (
        <Col style={{ width: '100%', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F5F7FA', padding: 16 }}>
            <Col
                style={{
                    width: '100%',
                    maxWidth: 480,
                    backgroundColor: '#FFFFFF',
                    borderRadius: 16,
                    padding: '40px 24px',
                    alignItems: 'center',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                }}
            >
                {/* 실패 아이콘 */}
                <div
                    style={{
                        width: 72,
                        height: 72,
                        borderRadius: 36,
                        backgroundColor: '#FEF2F2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                        <path d="M12 12l12 12M24 12L12 24" stroke={colors.ERROR} strokeWidth="3" strokeLinecap="round" />
                    </svg>
                </div>

                <Head4 style={{ color: colors.LAVEL_4, marginTop: 20 }}>
                    {isBilling ? '카드 등록에 실패했어요' : '결제가 완료되지 않았어요'}
                </Head4>

                {message && (
                    <Body3Regular style={{ color: colors.LAVEL_2, marginTop: 8, textAlign: 'center' }}>
                        {message}
                    </Body3Regular>
                )}

                <CaptionRegular style={{ color: colors.LAVEL_2, marginTop: 16, textAlign: 'center', lineHeight: '20px' }}>
                    잠시 후 다시 시도하거나,{'\n'}아래 버튼으로 센터에 문의해 주세요
                </CaptionRegular>

                {/* 버튼 영역 */}
                <Col style={{ width: '100%', gap: 8, marginTop: 32 }}>
                    <button
                        onClick={handleRetry}
                        style={{
                            width: '100%',
                            height: 52,
                            borderRadius: 12,
                            border: 'none',
                            cursor: 'pointer',
                            backgroundColor: colors.primary,
                            color: '#FFFFFF',
                            fontSize: 16,
                            fontWeight: 700,
                        }}
                    >
                        다시 시도하기
                    </button>
                    <button
                        onClick={() => window.close()}
                        style={{
                            width: '100%',
                            height: 44,
                            borderRadius: 12,
                            border: `1.5px solid ${colors.GREY_200}`,
                            cursor: 'pointer',
                            backgroundColor: '#FFFFFF',
                            color: colors.LAVEL_3,
                            fontSize: 14,
                            fontWeight: 500,
                        }}
                    >
                        센터에 문의하기
                    </button>
                </Col>
            </Col>
        </Col>
    );
};

export default MemberPaymentFailPage;
